import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function CurrencyFAQ() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Q1. What is a currency market and why is it needed?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      Foreign exchange is the most liquid, decentralised,
                      over-the-counter market, with a daily volume of more than
                      $6.6 trillion in 2019. Individuals and institutions from
                      all over the world buy and sell currencies on the currency
                      market. The foreign exchange market is crucial because it
                      allows currency conversion, which enables international
                      trade and investment. Participants include banks, central
                      banks, investment management firms, and investors.
                      Currency quotes are always displayed in pairs, the foreign
                      exchange market does not determine a currency's absolute
                      value, but rather its relative value by establishing the
                      market price of one currency if paid for with another.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  Q2. How can I trade in currency segment through Moneysukh?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      <li>
                        <span>Visit <a href="https://online.moneysukh.com" target="_blank">https://online.moneysukh.com</a> and login with your Moneysukh User ID & password.</span>
                      </li>
                      <li>
                        <span>Search for the Currency pair you want to trade in.</span>
                      </li>
                      <li>
                        <span>You must ensure that you have sufficient funds to trade in that security</span>
                      </li>
                      <li>
                        <span>Hover over the security and Tap on buy/sell. Fill in the necessary details like price, quantity, etc.</span>
                      </li>
                      <li>
                        <span>Conclude the transaction.</span>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Q3. What are the charges for trading in currency market?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                    You can check the charges for trading in currency segment from <a href="/Pricing" target="blank">here</a>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                {/* <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  Q4. Will I earn interest on my currency ledger balance?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>Yes, you will earn interest on your currency ledger balance.</p>
                  </Accordion.Body>
                </Accordion.Item> */}
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  Q4. Can I trade in the currency market using my regular trading account?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>Of course yes, you can trade in the currency market using your regular trading account.</p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default CurrencyFAQ;
